import { useEffect, useState } from 'react'
import { useAuth } from '../../providers/AuthProvider'
import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import styles from './Carts.module.css'
import Spinner from '../Spinner/Spinner'

export const Carts = () => {
  const [loadingCarts, setLoadingCarts] = useState(false)
  const { user, loading } = useAuth()
  const navigate = useNavigate()
  const [carts, setCarts] = useState([])
  const [orders, setOrders] = useState([])
  const getCarts = async () => {
    setLoadingCarts(true)
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/user/carts`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    )
    const data = await response.json()
    if (data.carts && data.carts.length > 0) {
      setCarts(data.carts)
    }
    setLoadingCarts(false)
  }
  const getOrders = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/user/orders`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    )
    const data = await response.json()
    if (data.orders && data.orders.length > 0) {
      setOrders(data.orders)
    }
  }

  useEffect(() => {
    if (loading) return
    if (!user || !user.user._id) {
      navigate('/auth')
      return
    }
    getCarts()
    getOrders()
  }, [user, loading, navigate])
  if (loadingCarts) {
    return <Spinner />
  }
  return (
    <div className={styles.container}>
      <div className={styles.cartsContainer}>
        <h1>{user?.user?.name}'s Active Carts</h1>
        <button
          type='button'
          className={styles.createCartButton}
          onClick={() => navigate('/catalogue')}
        >
          <FontAwesomeIcon icon={faPlus} className={styles.createCartIcon} />
          Create Cart
        </button>
        <div className={styles.usersTableContainer}>
          {carts.length === 0 ? (
            <p className={styles.noUsers}>No active carts found.</p>
          ) : (
            <table className={styles.usersTable}>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>No. of items</th>
                  <th>Total Amount</th>
                  <th>Created At</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {carts.map((cart) => (
                  <tr key={cart._id}>
                    <td>{user?.user?.name ?? '-'}</td>
                    <td>{cart.totalItems ?? '-'}</td>
                    <td>
                      ₹{Math.round(cart.price ?? 0).toLocaleString('en-IN')}
                    </td>
                    <td>
                      {cart.createdAt
                        ? new Date(cart.createdAt).toLocaleDateString('en-IN', {
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric',
                          })
                        : '-'}
                    </td>
                    <td className={styles.viewDetailsCell}>
                      <button
                        type='button'
                        className={styles.viewDetailsButton}
                        onClick={() => navigate(`/carts/${cart._id}`)}
                      >
                        View Details
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {orders.length > 0 && (
          <div className={styles.ordersContainer}>
            <h2 className={styles.ordersTitle}>My Orders</h2>
            <table className={styles.usersTable}>
              <thead>
                <tr>
                  <th>Cart Name</th>
                  <th>Amount</th>
                  <th>Total Products</th>
                  <th>Status</th>
                  <th>Created At</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {orders.map((order) => (
                  <tr key={order._id}>
                    <td>{order.cartName || 'Untitled Cart'}</td>
                    <td>
                      ₹
                      {Math.round(order.amount ?? 0).toLocaleString('en-IN')}
                    </td>
                    <td>{order.totalProducts ?? '-'}</td>
                    <td>{order.status ?? '-'}</td>
                    <td>
                      {order.createdAt
                        ? new Date(order.createdAt).toLocaleDateString(
                            'en-IN',
                            {
                              day: '2-digit',
                              month: 'short',
                              year: 'numeric',
                            }
                          )
                        : '-'}
                    </td>
                    <td className={styles.viewDetailsCell}>
                      <button
                        type='button'
                        className={styles.viewDetailsButton}
                        onClick={() =>
                          order.cartId && navigate(`/carts/${order.cartId}`)
                        }
                        disabled={!order.cartId}
                      >
                        View Details
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  )
}
